module.exports = __webpack_public_path__ + "static/media/icon-business.ac5f86be.svg";